import { HOME_PAGE } from '@/app/constants';

/**
 * 构造社区分享URL
 * @param id 社区灵感/短片/教程id
 * @param withOrigin 是否包含origin
 * @param pathname 路径
 * @returns
 */
export const generateCommunityShareUrl = ({
  id,
  withOrigin = true,
  pathname = '/feed-detail',
  isActivity = false,
}: {
  id: string;
  withOrigin?: boolean;
  pathname?: string;
  isActivity?: boolean;
}) => {
  const url = isActivity ? `${pathname}/activity/${id}` : `${pathname}/${id}`;
  return withOrigin ? window.location.origin + url : url;
};

/**
 * 构造主体分享URL（带参数）
 * @param id 主体id
 * @param pathname 路径
 * @returns
 */
export const generateCommunityShareUrlWithParams = ({
  id,
  pathname = HOME_PAGE,
}: {
  id: string;
  pathname?: string;
}) => {
  const params = { id };
  const encodedParams = btoa(JSON.stringify(params));
  const url = `${pathname}?params=${encodedParams}`;
  return window.location.origin + url;
};
